module.exports = __webpack_public_path__ + "img/ubq.721c96e2.svg";